/**
 * Single source of truth for all supported locales across the monorepo.
 *
 * When adding a new language:
 *   1. Add an entry to LOCALE_DEFINITIONS
 *   2. Create the .po file: apps/native/locales/{code}/messages.po
 *   3. Run: pnpm lingui:extract && pnpm lingui:compile
 *   4. Import the compiled messages in the native & extension i18n-providers
 */
export const LOCALE_DEFINITIONS = [
  { code: "en", flag: "🇺🇸", label: "English", englishLabel: "English", isRTL: false },
  { code: "es", flag: "🇪🇸", label: "Español", englishLabel: "Spanish", isRTL: false },
  { code: "pt", flag: "🇧🇷", label: "Português", englishLabel: "Portuguese", isRTL: false },
  { code: "fr", flag: "🇫🇷", label: "Français", englishLabel: "French", isRTL: false },
  { code: "de", flag: "🇩🇪", label: "Deutsch", englishLabel: "German", isRTL: false },
  { code: "ko", flag: "🇰🇷", label: "한국어", englishLabel: "Korean", isRTL: false },
  { code: "ja", flag: "🇯🇵", label: "日本語", englishLabel: "Japanese", isRTL: false },
  { code: "zh", flag: "🇨🇳", label: "中文", englishLabel: "Chinese", isRTL: false }, // Simplified (zh-Hans)
  { code: "hi", flag: "🇮🇳", label: "हिन्दी", englishLabel: "Hindi", isRTL: false },
  { code: "ar", flag: "🇸🇦", label: "العربية", englishLabel: "Arabic", isRTL: true },
  { code: "he", flag: "🇮🇱", label: "עברית", englishLabel: "Hebrew", isRTL: true },
] as const;

/** Locale code union derived from LOCALE_DEFINITIONS. */
export type SupportedLocale = (typeof LOCALE_DEFINITIONS)[number]["code"];

/** All locale codes derived from LOCALE_DEFINITIONS — runtime array. */
export const SUPPORTED_LOCALES: SupportedLocale[] = LOCALE_DEFINITIONS.map((l) => l.code);

/** Set of RTL locale codes derived from LOCALE_DEFINITIONS. */
export const RTL_LOCALES = new Set<SupportedLocale>(
  LOCALE_DEFINITIONS.filter((l) => l.isRTL).map((l) => l.code),
);

/** The locale to use when no stored preference or device locale is matched.*/
export const DEFAULT_LOCALE: SupportedLocale = "en";
